<template>
  <div
    class="w-full rounded-3xl mb-5 border-2 bg-white !border-[#2191da] p-5 lg:p-7 lg:pb-10 gap-7 grid content-start max-w-[400px]">
    <div class="w-full flex justify-between items-center">
      <h2 class="font-black text-[#3057B4] text-3xl md:text-2xl font-openSans">Sign In</h2>
      <a :href="'/signup'" class="underline text-[#2191da] text-sm font-openSans">
        I don't have an account</a>
    </div>

    <form class="w-full px-3 grid gap-7 content-start">
      <v-alert outline :model-value="error" type="error">{{ errorMsg }}</v-alert>
      <GoogleAuth @token="handleGoogleLogin" />
      <v-text-field v-model="formData.username" class="!border-2 !border-primary-dark px-2 py-1 rounded-md"
        :disabled="loadingResponse" v-on:keyup.enter="onEnterKey" name="username" label="Email" type="email"
        variant="plain" :hide-details="true" />

      <v-text-field v-model="formData.password" class="!border-2 !border-primary-dark px-2 py-1 rounded-md"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
        :disabled="loadingResponse" v-on:keyup.enter="onEnterKey" name="input-10-1" label="Password" variant="plain"
        @click:append="showPassword = !showPassword" :hide-details="true" />

      <div class="w-full grid gap-2">
        <v-btn :disabled="!formData.username || !formData.password || loadingResponse" variant="flat"
          class="!py-3 !bg-[#3057B4] !font-openSans !font-black !text-xl !capitalize !text-white !h-auto !tracking-normal"
          @click="login" :loading="loadingResponse">Login
        </v-btn>

        <a class="cursor-pointer text-[grey] text-left font-openSans text-sm" v-on:click="goRecovery">
          Forgot your password?
        </a>
      </div>
    </form>

    <div class="flex justify-center divide-x divide-[#2258bb] px-3">
      <a class="cursor-pointer text-[#2258bb] font-openSans underline text-left px-2 text-sm"
        :href="webBaseUrl + '/terms_of_use/'" target="_blank">Terms of Service</a>
      <a class="cursor-pointer text-[#2258bb] font-openSans underline text-left px-2 text-sm"
        :href="webBaseUrl + '/privacy-policy/'" target="_blank">Privacy Policy</a>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { login, googleAuth } from '../../actions/auth';
import { usePayloadStore } from '../../stores/payload';
import GoogleAuth from '@/components/auth/GoogleAuth.vue';

@Options({
  components: {
    GoogleAuth
  }
})
export default class LoginForm extends Vue {
  public loadingResponse = false;
  public webBaseUrl = process.env.WEB_BASE_URL;
  public formData = {
    username: '',
    password: ''
  };

  public error = false;

  public showPassword = false;

  public errorMsg = '';

  public goRecovery() {
    window.location.href = '/accounts/password_reset';
  }

  private payloadStore = usePayloadStore();

  public onEnterKey = () => {
    if (this.formData.username && this.formData.password && !this.loadingResponse) {
      this.login();
    }
  };

  public login = () => {
    this.loadingResponse = true;
    login(this.formData)
      .then((res: any) => {
        if (localStorage.getItem('viewedTutorial') !== '1') localStorage.setItem('viewedTutorial', '0');
        if (!res?.version_access?.map((version: string) => version.toLowerCase()).includes('english')) {
          this.error = true;
          this.errorMsg =
            'You have no access to this version of the software. Contact support@writewise.io to upgrade your plan.';
          this.loadingResponse = false;
          return;
        }
        this.payloadStore.change({ user: res.user, token: res.token, refresh: res.refresh });
        this.error = false;
        this.loadingResponse = false;
        window.location.href = '/dashboard/documents';
      })
      .catch((err) => {
        console.log(err);
        this.error = true;
        this.errorMsg =
          err?.response?.data?.detail || 'Incorrect username or password, please try again';
        this.loadingResponse = false;
      });
  };

  public handleGoogleLogin = (token: string) => {
    this.loadingResponse = true;
    googleAuth({ token })
      .then((res: any) => {
        if (localStorage.getItem('viewedTutorial') !== '1') localStorage.setItem('viewedTutorial', '0');
        if (!res?.version_access?.map((version: string) => version.toLowerCase()).includes('english')) {
          this.error = true;
          this.errorMsg =
            'You have no access to this version of the software. Contact support@writewise.io to upgrade your plan.';
          this.loadingResponse = false;
          return;
        }
        this.payloadStore.change({ user: res.user, token: res.token, refresh: res.refresh });
        this.error = false;
        this.loadingResponse = false;
        window.location.href = '/dashboard/documents';
      })
      .catch((err) => {
        console.log(err);
        this.error = true;
        this.errorMsg =
          err?.response?.data?.detail || 'Google auth failed, please try again';
        this.loadingResponse = false;
      });
  };
}
</script>
